import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { bonusPluralize, monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { getTicketDataLayerLabel, pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { setTicketPopup } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { ddmm } from '~/src/helpers/date';
import { toCurrency } from '~/src/helpers/numbers';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { selectSeasonTicketPaySum } from '../selectors/selectPaymentSum';

interface IStatusProps {
    isSuccess: boolean,
}

interface ISuccesStatusProps extends IStatusProps {
    isSuccess: true,
    payStatus: number,
}

interface IErrorStatusProps extends IStatusProps {
    isSuccess: false,
    payStatus?: never,
}

export type TPaymentStatus = ISuccesStatusProps | IErrorStatusProps

export const processingPaymentText = 'Если через ХХ часов не удастся зачислить деньги на ваш лицевой счёт, вернём их вам на карту. ' +
    'Абонемент заработает, когда на счету будет достаточно денег.';

const getInfoByPaymentStatus = ({ isSuccess, payStatus }: TPaymentStatus) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const {
            payment: { result },
            seasonTicketPayment: { seasonTicket, bonusesInfo: { isUseBonuses, amount: bonusesAmount } },
        } = state;
        const { activateDate = '', paySum = 0, countMonth = 3, sumPrice = 0, deltaPeriod = 0 } = seasonTicket || {};

        const seasonTicketPaySum = selectSeasonTicketPaySum(state);
        const cardPaymentSum = toCurrency(seasonTicketPaySum);


        dispatch(setPaymentResult({ ...result, frameUrl: '' }));

        if (!isSuccess) {
            pushDataLayer('subscription_connect_success', getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }));
            dispatch(setTicketPopup({
                isOpen: true,
                step: 'declined',
                title: 'Что-то пошло не так',
                type: EResultPopupStatus.ERROR,
            }));

            return;
        }

        switch (payStatus) {
            case 1: {
                pushDataLayer('subscription_and_payment_success', getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }));
                dispatch(setTicketPopup({
                    isOpen: true,
                    step: 'paid',
                    title: `Вы пополнили баланс на ${toCurrency(paySum)} ${RubleSymbol} и подключили абонемент на ${countMonth} ${pluralize(countMonth, monthPluralize)}`,
                    text: `Абонемент начнёт действовать ${ddmm(activateDate)}`,
                    type: EResultPopupStatus.SUCCESS,
                }));

                break;
            }
            case 0: {
                pushDataLayer('subscription_connect_success', getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }));
                dispatch(setTicketPopup({
                    isOpen: true,
                    step: 'declined',
                    title: 'Вы подключили абонемент, но пополнить баланс не получилось',
                    type: EResultPopupStatus.WARNING,
                }));

                break;
            }
            default: {
                pushDataLayer('subscription_and_payment_success', getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }));
                const additionalText = isUseBonuses
                    ? `Баланс будет пополнен на ${cardPaymentSum} ${RubleSymbol}. С бонусного счета списали ${bonusesAmount} ${pluralize(bonusesAmount, bonusPluralize)}. `
                    : '';

                dispatch(setTicketPopup({
                    isOpen: true,
                    step: 'paid',
                    title: 'Обрабатываем ваш платёж',
                    text: `${additionalText}${processingPaymentText}`,
                    type: EResultPopupStatus.WARNING,
                }));

                break;
            }
        }
    };
};

export default getInfoByPaymentStatus;
